export default {
  setRentProducts(state, rentProducts) {
    state.rentProducts = rentProducts
  },
  setLoading(state, loading) {
    state.loading = loading
  },
}
